import { IApproval, ICompliance, IField } from '@/types/tasksApprovals'

import DefaultField from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/default'
import AmountInput from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/amountInput'
import CommentsType from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/comments'
import DateType from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/date'
import DateInterval from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/dateInterval'
import DrowpDown from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/dropdown'
import LinkType from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/link'
import NumberType from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/number'
import TableType from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/table/TNE/Container'
import TimeOfDetails from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/timeOffDetails'
import User from '../pages/components/tasksApprovals/detailsDrawer/body/layouts/components/fields/type/user'

export const generateFieldsByType = (field: IField, item: ICompliance | IApproval) => {
    switch (field.type) {
        case 'table':
            return <TableType item={field} />
        case 'number':
            return <NumberType item={field} />
        case 'user':
            return <User item={field} />
        case 'comments':
            return <CommentsType item={field} />
        case 'date':
            return <DateType item={field} system={item.system_id} />
        case 'date-interval':
            return <DateInterval item={field} />
        case 'input':
            if (item.system_id === 'GRP') {
                return <AmountInput item={field} />
            }
            break
        case 'time_off_details':
            if (item.system_id === 'WORKDAY_LEAVE_REQUESTS') {
                return <TimeOfDetails item={field} />
            }
            break
        case 'link':
            return <LinkType item={field} />
        case 'categories':
            if (item.system_id === 'GRP') {
                return <DrowpDown item={field} />
            }
            break
        default:
            return <DefaultField item={field} />
    }
}
